import React, { useContext } from 'react';
import { ToastContext } from '../contexts/ToastContext';
import './Toast.css';

/**
 * Toast component for displaying temporary notifications
 * 
 * This component automatically appears and disappears based on the toast state in ToastContext
 */
function Toast() {
  const { toast, hideToast } = useContext(ToastContext);
  
  // Add a class based on the toast type
  const toastClass = `toast ${toast.type} ${toast.visible ? 'visible' : ''}`;
  
  return (
    <div className={toastClass} onClick={hideToast}>
      <div className="toast-content">
        {toast.type === 'info' && <span className="toast-icon">🔄</span>}
        {toast.type === 'success' && <span className="toast-icon">✅</span>}
        {toast.type === 'error' && <span className="toast-icon">⚠️</span>}
        <span className="toast-message">{toast.message}</span>
      </div>
    </div>
  );
}

export default Toast;